
import { Footer } from "../components/Footer";
import Header from "../components/Header";
import FaqPage from "../views/Faq/FaqPage";
import { HomePage } from "../views/home/HomePage";

const Faq=()=>{
    window.scrollTo(0, 0);

    return(
        <>
        <Header/>
        <FaqPage/>
        <Footer/>
        </>
    )
}


export default Faq;